import * as styles from './styles.css';
import { Button, Theme, Tooltip, useDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';
import { TUser } from 'shared/types/user';

interface IDoorsProps {
  doors: JSX.Element[];
  user: TUser | null;
  isAllDoorsOpened: boolean;
  onPointsBtnClick: VoidFunction;
}

export const Doors: React.FC<IDoorsProps> = ({ doors, user, isAllDoorsOpened, onPointsBtnClick }) => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      {user && (
        <div className={styles['points-with-btn']}>
          <div className={styles['points-container']}>
            <div className={styles['points']}>Ваши баллы: {user.points}</div>
            {!isAllDoorsOpened && (
              <Tooltip theme="white" title="Кнопка «Забрать баллы» появится, когда откроете все дверцы">
                <div className={styles['points-tooltip']} />
              </Tooltip>
            )}
          </div>
          {isAllDoorsOpened && (
            <div className={styles['btn']}>
              <Theme theme="onOverlay">
                <Button theme="fill_secondary" fullWidth onClick={onPointsBtnClick}>
                  Забрать баллы
                </Button>
              </Theme>
            </div>
          )}
        </div>
      )}
      <div className={styles['doors']}>{doors}</div>
    </div>
  );
};
